import React from 'react'
import styled from '@emotion/styled'
import * as v from 'variables/styles'

const DataCellContainer = styled.div(props => ({
  width: '100%',
  borderBottom: `solid 1px ${v.borderGray}`,
  padding: '10px 5px',
  cursor: 'pointer',
  background: props.selected ? v.ezMainColor : 'inherit'
}))

const DataCell = (props) => {
  const { data, selected, onClick } = props

  return (
    <DataCellContainer selected={selected} onClick={() => onClick(data.id)}>
      {
        data.nameTh
      }
    </DataCellContainer>
  )
}

export default DataCell